import './App.css';
import React from "react";
import {Route, Routes} from "react-router-dom";
import AppRoute from "./routes/AppRoute";

function App() {
  return (
    <div className="App">
      <React.Fragment>
        <Routes>
          <Route path={"*"} element={<AppRoute />} />
        </Routes>
      </React.Fragment>
    </div>
  );
}

export default App;
